import { SingleValueFormFieldModel } from 'app/overview/config/configuration_tab/general/frontend_config/AbstractSingleValueFormFieldModel';

export class BooleanFormFieldModel extends SingleValueFormFieldModel<boolean> {
    setValue(val: any) {
        this._valueUnderEdit = this.convertValueForEditing(val);
        this._notifyListeners();
    }

    convertValueForEditing(value) {
        return !!value;
    }
}
